import { useEffect } from 'react';

import useCommon from './common';
import { useListPresenter } from './list';
import { useSeenPresenter } from './seen';
import { useTabsPresenter } from './tabs';

export default (params, popupInstance) => {
  const userReactionsList = useListPresenter();
  const userSeen = useSeenPresenter(params);

  const tabs = useTabsPresenter({
    userReactionsList,
    userSeen,
    tab: params.tab,
  });

  const common = useCommon({
    userReactionsList,
    userSeen,
    tabs,
    popupInstance,
    groupId: params.groupId,
    messageId: params.messageId,
  });

  useEffect(() => {
    common.initUserReactions();
  }, []);

  return { tabs, common };
};
